import * as React from 'react';
import { Button, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';

import * as styles from './FindApartment.css';
import LookingSvg from './images/looking.svg';

export interface IFindApartmentProps {
  buttonsRef: React.RefObject<HTMLDivElement>;
  onCallButtonClick: () => void;
  onRequestButtonClick: () => void;
  isCallConsultantButtonHidden: boolean;
}

export const FindApartment: React.FC<IFindApartmentProps> = ({
  buttonsRef,
  onCallButtonClick,
  onRequestButtonClick,
  isCallConsultantButtonHidden,
}) => {
  const deviceType = useDeviceType();

  const buttonSize: TButtonSize = deviceType === 'tablet' || deviceType === 'phone' ? 'M' : 'L';
  const UIText = deviceType === 'phone' ? UIText2 : UIText1;

  return (
    <section className={styles['find-apartment']} data-testid="FindApartment">
      <div className={styles['background-wrapper']}>
        <div className={styles['image-wrapper']}>
          <img src={LookingSvg} className={styles['image']} />
        </div>
        <div className={styles['text-and-buttons']}>
          <div className={styles['title']}>Начните поиск квартиры&nbsp;мечты</div>
          <div className={styles['description']}>
            <UIText>
              Расскажите, что ищете — консультант перезвонит в течение суток, уточнит подробности и ответит на все
              вопросы
            </UIText>
          </div>
          <div className={styles['button-group']} ref={buttonsRef}>
            {!isCallConsultantButtonHidden && (
              <div className={styles['button']}>
                <Button fullWidth size={buttonSize} onClick={onCallButtonClick}>
                  Позвонить консультанту
                </Button>
              </div>
            )}
            <div className={styles['button']}>
              <Button fullWidth size={buttonSize} theme="fill_white_primary" onClick={onRequestButtonClick}>
                Оставить заявку
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
